import React from 'react'
import connect from 'redux-connect-decorator'
import { Layout } from 'antd'
import classes from './PageLayout.module.scss'
import { languageChange } from 'store/siteConfig'
// import { FormattedMessage } from 'react-intl'

@connect(state => ({
  siteConfig: state.siteConfig
}), {
  languageChange
})
class PageLayout extends React.Component {
  // constructor(props) {
  //   super(props)
  // }
  render() {
    const { children } = this.props
    return (
      <Layout className={classes.main}>
        <Layout.Header className={`${classes.header} ${this.props.className}`}>
          <img width='144' src={require('./images/PayBy.svg')} />
        </Layout.Header>
        <Layout className={classes.content}>
          <Layout.Content>{children}</Layout.Content>
        </Layout>
      </Layout>
    )
  }
}

export default PageLayout
